import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Observable } from "rxjs";

export interface Props {
    guias: Observable<models.GuiaDTO[]>;
}

const columns: kea.Grid2Column<models.GuiaDTO>[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Tipo de acuse", cell: x => ({ data: x.ServiciosAdicionales.TipoAcuse == null ? null : models.TipoAcuse[x.ServiciosAdicionales.TipoAcuse] }) },
    { title: "Requerimiento acuse externo", cell: x => ({ data: x.ServiciosAdicionales.NombreRequerimientoAcuse }) }
];

const Alerta = () =>
    <div className="alert alert-info">
        <label>
            <i className={fa("file-o", "fw")} />
            Se generarán los siguientes acuses
        </label>
        <br />
        Al finalizar el pago se generará una guia de acuse por cada una de estas guias:
    </div>;

/**
 * Muestra el listado de las guias que van a generar acuses
 */
export class AcusesList extends React.PureComponent<Props> {
    guias = (props: Props) => props.guias;
    conAcuses = createSelectorRx(this.guias, guias => guias.filter(x => x.ServiciosAdicionales.TipoAcuse != null));

    render() {
        return (
            <div>
                <Alerta />
                <kea.Grid2 items={this.conAcuses(this.props)} columnas={columns} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/acuses/index.tsx